import { maxSwissRounds, suggestedSwissRounds } from "@rally/draw";

/**
 * The round counts a Swiss event can be set to now: never fewer than the rounds already drawn
 * (or 1), never more than the field minus one, the most it can play without a rematch being
 * certain. Empty when the field is too small to pair.
 */
export function swissRoundChoices(entrants: number, drawn: number): number[] {
  if (entrants < 2) return [];
  const low = Math.max(1, drawn);
  const high = maxSwissRounds(entrants);
  return Array.from({ length: Math.max(0, high - low + 1) }, (_, i) => low + i);
}

/**
 * What the picker shows: the stored count while it is still allowed, else the suggestion — enough
 * rounds to separate a single leader — kept inside what is allowed.
 */
export function swissRoundDefault(
  entrants: number,
  drawn: number,
  stored: number | null,
): number | null {
  const choices = swissRoundChoices(entrants, drawn);
  if (choices.length === 0) return null;
  if (stored != null && choices.includes(stored)) return stored;
  const suggested = suggestedSwissRounds(entrants);
  return Math.min(Math.max(suggested, choices[0] as number), choices[choices.length - 1] as number);
}
